import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import LogicNodeModel from "./LogicNodeModel";
import LogicNodeWidget from "./LogicNodeWidget";

export default class LogicNodeFactory extends AbstractReactFactory {
  constructor() {
    super("logic");
  }

  generateModel(data) {
    return new LogicNodeModel({ engine: this.engine, data });
  }

  generateReactWidget(event) {
    return <LogicNodeWidget engine={this.engine} node={event.model} />;
  }
}
